/**
 * Accordion Scroll Behavior
 * Adds functionality to scroll to accordion content when opened on desktop
 */
document.addEventListener("DOMContentLoaded", function () {
    // Initialize accordions with scroll behavior for desktop
    initAccordionScrollBehavior();
});

function initAccordionScrollBehavior() {
    // Get all accordion elements
    const accordions = document.querySelectorAll(".product-details__accordion");

    // Add click event listener to each accordion
    accordions.forEach((accordion) => {
        accordion.addEventListener("toggle", function () {
            // Only execute scrolling if the accordion is open and screen width is larger than 1160px
            if (this.open && window.innerWidth >= 1160) {
                // Get the accordion summary (header)
                const accordionSummary = this.querySelector(
                    ".product-details__accordion-summary"
                );

                // Get the info column container that needs to be scrolled
                const infoColumn = document.querySelector(
                    ".product-details__info-column"
                );

                // If summary exists and info column exists, scroll the info column
                if (accordionSummary && infoColumn) {
                    // Use a longer timeout to ensure the accordion is fully open
                    setTimeout(() => {
                        // Get the current position of the accordion summary relative to the info column
                        const summaryRect =
                            accordionSummary.getBoundingClientRect();
                        const infoColumnRect =
                            infoColumn.getBoundingClientRect();

                        console.log({ summaryRect });
                        console.log({ infoColumnRect });

                        // Calculate how far we need to scroll
                        // This is the distance from the top of the info column to the accordion summary
                        // plus the current scroll position of the info column
                        const scrollToPosition =
                            infoColumn.scrollTop +
                            (summaryRect.top - infoColumnRect.top);

                        console.log({ scrollToPosition });

                        // Smooth scroll the info column to position the summary at the top
                        infoColumn.scrollTo({
                            top: scrollToPosition,
                            behavior: "smooth",
                        });
                    }, 240); // Increased timeout for better reliability
                }
            }
        });
    });
}
